import {getMethod} from '~/api'

async function get(link) {
    return await getMethod(`/cms/info-pages/${link}`, {})
}

export {get}
